import { Group, Select, Stack } from '@mantine/core';
import { inkLight, secondaryBase } from '../../styles/design-tokens';
import { Divider } from '../../ui-library/divider/divider';
import { Icon } from '../../ui-library/icon/icon';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { Text } from '../../ui-library/typography/typography';
import { toComboboxData } from './filter-panel.helpers';
import type { FilterGroup } from './filter-panel.type';

type Props<T extends FilterGroup> = {
  group: T;
  handleSelectChange: (group: T, value: string) => void;
  hasDivider?: boolean;
};

export const FilterPanelGroupSelect = <T extends FilterGroup>({
  group,
  handleSelectChange,
  hasDivider = true,
}: Props<T>) => {
  return (
    <Stack key={group.name} gap={16}>
      <Group justify="space-between">
        <Group gap="xs">
          {group.icon && <Icon name={group.icon} size={16} color={inkLight} />}
          <Text weight="medium" size="small">
            {group.name}
          </Text>
          {group.tooltip && (
            <Tooltip label={group.tooltip} variant="black" multiline maw={300}>
              <Icon name="info" size={16} color={secondaryBase} />
            </Tooltip>
          )}
        </Group>
      </Group>

      <Select
        value={group.selectedValues.length > 0 ? group.selectedValues[0] : null}
        data={toComboboxData(group.options)}
        onChange={(value) => handleSelectChange(group, value as string)}
        placeholder={`Select ${group.name}`}
        clearable={group.optional}
        allowDeselect={group.optional}
        radius="xl"
        searchable={group.searchable}
        disabled={group.disabled}
      />
      {hasDivider && <Divider style={{ marginTop: '8px' }} />}
    </Stack>
  );
};
